import { Box, styled } from "@mui/material";

export const ContentWrapper = styled(Box)({
  display: "flex",
  flex: 1,
  marginTop: "calc(var(--bannerHeight, 0px) + var(--topNavigationHeight, 0px))",
  marginLeft: "var(--leftPanelWidth, 0px)",
  minHeight: "100%",
});
